/*=========================================================================================
  File Name: moduleCountryActions.js
  Description: Country Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
 fetchDataListItems({ commit }) {
      return axios.get("/api/Investor/GetAll").then(res => {
        commit('SET_INVESTORS', res.data.Data);
      });
    },
 fetchInvestorCategories({ commit }) {
      return axios.get("/api/InvestorCategory/GetAll").then(res => {
        commit('SET_INVESTOR_CATEGORIES', res.data.Data);
      });
    },
     fetchInvestorKycStatus({ commit }) {
      return axios.get("/api/InvestorKycStatus/GetAll").then(res => {
        commit('SET_INVESTOR_KYC_STATUS', res.data.Data);
      });
    },
     fetchTokenStatus({ commit }) {
      return axios.get("/api/TokenStatus/GetAll").then(res => {
        commit('SET_TOKENSTATUS', res.data.Data);
      });
    },
GetItemByID({ commit }, itemid) {

  return new Promise((resolve, reject) => {

    axios.get(`API/Investor/GetById/${itemid}`, {
      headers: { Authorization: 'Bearer ' + localStorage.accessToken }
    })
    .then((response) => {
    
      commit('GET_ITEM_BY_ID', response.data.Data); 
      resolve(response);
    })
    .catch((error) => { reject(error) });
  });
},
  updateItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      
      axios.put("API/Investor/Update", item
        ,{headers: { Authorization: 'Bearer ' + localStorage.accessToken,}}
      )
        .then(response => {
        
          commit('UPDATE_INVESTOR', item);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
toggleInvestorStatus({ commit }, id) {
  return new Promise((resolve, reject) => {
    axios.put(`/api/Investor/ToggleStatus/${id}`)
      .then((response) => {

        if (response.data.Success || response.data.isSuccess) {
          commit('TOGGLE_INVESTOR_ACTIVE_STATUS', id);
          resolve(response);
        } else {
          reject(response.data.Message);
        }
      })
      .catch((error) => { reject(error); });
  });
},


  fetchFilteredInvestors({ commit }, filters) {
    return axios.post("/api/Investor/Search", filters) 
      .then((response) => {
        commit("SET_INVESTORS", response.data.Data);
      })
      .catch((error) => { console.error(error); });
  },

  removeItem({ commit }, item) {
    
    return new Promise((resolve, reject) => {
      axios.delete(`API/Token/Delete/${item.Id}`, {
        headers: { Authorization: 'Bearer ' + localStorage.accessToken }
      })
        .then((response) => {
          commit('REMOVE_ITEM', item.id)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
